/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EComLang } from "../types/EComLang.ts";

/**
 * @description 1 = ptBR | 2 = esES | 3 = enUS | 4 = frFR | 5 = arAE | 6 = ruRU | 7 = zhHans | 8 = bgBG | 9 = csCZ | 10 = daDK | 11 = deDE | 12 = elGR | 13 = etEE | 14 = fiFI | 15 = hrHR | 16 = trTR | 17 = huHU | 18 = itIT | 19 = ltLT | 20 = lvLV | 21 = nlNL | 22 = plPL | 23 = roRO | 24 = skSK | 25 = slSI | 26 = svSE |
 */
export const eComLangSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
    z.literal(11),
    z.literal(12),
    z.literal(13),
    z.literal(14),
    z.literal(15),
    z.literal(16),
    z.literal(17),
    z.literal(18),
    z.literal(19),
    z.literal(20),
    z.literal(21),
    z.literal(22),
    z.literal(23),
    z.literal(24),
    z.literal(25),
    z.literal(26),
  ])
  .describe(
    "1 = ptBR | 2 = esES | 3 = enUS | 4 = frFR | 5 = arAE | 6 = ruRU | 7 = zhHans | 8 = bgBG | 9 = csCZ | 10 = daDK | 11 = deDE | 12 = elGR | 13 = etEE | 14 = fiFI | 15 = hrHR | 16 = trTR | 17 = huHU | 18 = itIT | 19 = ltLT | 20 = lvLV | 21 = nlNL | 22 = plPL | 23 = roRO | 24 = skSK | 25 = slSI | 26 = svSE | ",
  ) as unknown as ToZod<EComLang>;
